<template>
  <v-container>
    <v-row v-if="sample">
      <v-col>
        <v-card class="ma-3 rounded-lg" flat elevation="3">
          <v-card-text>
            <v-row :class="this.$vuetify.breakpoint.name == 'xl' ||
                this.$vuetify.breakpoint.name == 'lg' ||
                this.$vuetify.breakpoint.name == 'md'
                ? 'mx-3'
                : ''
              ">
              <v-col class="
                      pb-0
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                    ">
                {{ sample.soilArea.name }}
              </v-col>
              <v-col align="end">
                <v-icon @click="openDialog(sample.notes, sample.phenologicalStage)">
                  mdi-information
                </v-icon>
              </v-col>
            </v-row>
            <v-row :class="this.$vuetify.breakpoint.name == 'xl' ||
                this.$vuetify.breakpoint.name == 'lg' ||
                this.$vuetify.breakpoint.name == 'md'
                ? 'mx-3'
                : ''
              ">
              <v-col cols="8">
                <!-- contetn left column -->
                <v-row>
                  <v-col class="
                      py-1
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                      text-start
                    "><v-icon>mdi-qrcode</v-icon>
                    <span>
                      {{
                        sample.container
                          ? sample.container.code
                          : "--------------"
                      }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="mt-1 mb-0">
                  <v-col class="
                      pt-1
                      pb-0
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                      text-start
                    ">
                    <span>
                      {{ dateFormatted }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="my-0">
                  <v-col class="
                      py-0
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                      text-start
                    ">
                    <span>
                      {{ fullNameSample }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="my-0">
                  <v-col class="
                      py-0
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                      text-start
                    ">
                    <span>
                      {{ CropName }}
                    </span>
                    <span>
                      {{ cropDate }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4" align-self="end">
                <v-row class="text-end">
                  <v-col>
                    <v-btn color="primary" small rounded @click="showUpdateSampleInfoModal = true">
                      {{ translations.label_update }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row align="center" justify="end">
                  <v-col class="
                      justify-end
                      align-center
                      row
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                    ">
                    <span class="mr-2"> {{ sample.subSamples.length }}</span>
                    <v-img class="mr-2" max-width="16" max-height="16" @click="showAll"
                      :src="require('@/assets/img/flag_target.png')"></v-img>
                  </v-col>
                </v-row>
                <v-row align="end">
                  <v-col class="
                      text-caption
                      text-sm-subtitle-1
                      text-md-subtitle-1
                      text-lg-subtitle-1
                      text-xl-subtitle-1
                      text-end
                      secondary--text
                    ">
                    <v-row v-if="sample.status == 'NOT_STARTED'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="14">mdi-close</v-icon>
                      <span class="mr-3">{{
                        translations.label_sampling_not_started
                        }}</span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'IN_PROGRESS'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-timer-sand</v-icon>
                      <span class="mr-3">
                        {{ translations.label_sampling_in_progress }}
                      </span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'VALIDATED'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-check</v-icon>
                      <span class="mr-3">
                        {{ translations.label_sampling_finished }}
                      </span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'SENT'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-truck-delivery</v-icon>
                      <span class="mr-3"> {{ translations.label_sent }}</span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'RECEIVED'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-check-all</v-icon>
                      <span class="mr-3">{{
                        translations.label_received
                        }}</span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'MEASURING'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-timer-sand</v-icon>
                      <span class="mr-3">
                        {{ translations.label_measuring }}
                      </span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'MEASURED'" class="d-flex justify-end">
                      <v-icon color="secondary" size="20">mdi-chart-line-variant</v-icon>
                      <span class="mr-3">
                        {{ translations.label_measured }}
                      </span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'VALUATING'" class="d-flex justify-end">
                      <v-icon class="pr-1" color="secondary" size="20">mdi-timer-sand</v-icon>
                      <span class="mr-3">
                        {{ translations.label_valuating }}
                      </span>
                    </v-row>
                    <v-row v-else-if="sample.status == 'VALUATED'" class="d-flex justify-end">
                      <v-icon color="secondary" class="pr-1" size="20">mdi-chart-line-variant</v-icon>
                      <span class="mr-3">
                        {{ translations.label_valuated }}
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-if="
            sample &&
            (sample.soilArea.location ||
              (sample.soilArea.polygon &&
                sample.soilArea.polygon.length > 0))
          ">
            <map-sample :sample="sample"></map-sample>
          </div>
          <div v-else>
            <v-card style="background-color: #aaabac" class="here-map__container">
              <v-card-text>
                <v-row class="text-center">
                  <v-col>
                    <span class="font-weight-bold">{{
                      translations.label_polygon_not_available
                      }}</span></v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-skeleton-loader type="list-item-three-line, divider,  card-heading, image"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-dialog v-model="sheet" :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'" persistent>
      <v-card class="rounded-lg cardColor">
        <v-card-text>
          <p class="
              text-center
              my-3
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            ">
            {{ translations.label_subsample_photos }}
          </p>
          <v-carousel hide-delimiter-background :show-arrows="true" height="auto" class="mt-0" v-model="navigation">
            <v-carousel-item v-for="(item, i) in urls" :key="i">
              <v-img v-if="item.img != ''" :src="item.img" contain>
                <v-btn v-if="item.description.length > 0" @click="openDialog(item.description)" color="green" small
                  absolute top right fab class="mt-10">
                  <v-icon color="white">mdi-information-outline</v-icon>
                </v-btn>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img v-else :src="require('@/assets/img/no_image_icon.png')" contain>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
        <v-card-actions>
          <!-- <v-row>
                  <v-col> -->
          <v-btn color="green" @click="sheet = false" block dark class="mb-1">
            {{ translations.label_close }}
          </v-btn>
          <!-- </v-col>
                </v-row> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row v-if="this.description.length > 0">
              <v-col>
                <span class="text-h6 lighten-2">{{
                  translations.label_sample_description
                  }}</span>
                <v-spacer></v-spacer>
                {{ this.description }}
              </v-col>
            </v-row>
            <v-row v-if="this.pheno.length > 0">
              <v-col>
                <span class="text-h6 lighten-2">{{
                  translations.label_phonological_stage
                  }}</span>
                <v-spacer></v-spacer>
                {{ getPeheno(this.pheno) }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="openDialog">
            {{ translations.accept }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
    <!-- modal -->
    <UpdateSampleInfoModal v-model="showUpdateSampleInfoModal" v-if="showUpdateSampleInfoModal" />
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

// Components

import moment from "moment";
import MapSample from "../components/territory/MapSample.vue";
import UpdateSampleInfoModal from "../components/territory/modals/UpdateSampleInfoModal.vue";
export default {
  data: () => ({
    dialog: false,
    description: "",
    pheno: "",
    soilArea: null,
    sample: null,
    dateFormatted: "",
    fullNameSample: "",
    CropName: "",
    cropDate: "",
    urls: [],
    sheet: false,
    navigation: null,
    showUpdateSampleInfoModal: false
  }),
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("samples", ["SET_AREA_SELECTED_SAMPLE", "SET_SHOW_ALL"]),
    ...mapActions("samples", ["getSampleById"]),
    getFormatted(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    getFormattedSimple(date) {
      if (date.lenght > 0) {
        return moment(date).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    goBack() {
      this.$router.back();
      // if (this.area_selected) {
      //   this.SET_AREA_SELECTED_SAMPLE(this.area_selected);
      //   this.$router.push(`/samples?fromAreaDetail=true`);
      // } else {
      //   this.$router.push("/samples");
      // }
    },
    setCropName(name) {
      return this.translations.crop_name_list[name] || name;
    },
    async getCropName() {
      if (this.sample.soilArea.landUse === "sterile") {
        this.CropName = this.translations.landUse_list["sterile"];
      } else {
        try {
          if (this.sample.cropCycle) {
            this.CropName = this.setCropName(
              this.sample.cropCycle.crop.cropName
            );

            if (this.sample.cropCycle.plantDate.lenght > 0) {
              this.cropDate =
                " " + this.getFormattedSimple(this.sample.cropCycle.plantDate);
            }

            if (this.sample.cropCycle.harvestDate > 0) {
              +" - " +
                this.getFormattedSimple(this.sample.cropCycle.harvestDate);
            }
          } else {
            this.CropName = "";
          }
        } catch (error) {
          console.log("ERROR: ", error);
          this.CropName = "";
        }
      }
    },
    showAll() {
      if (
        this.sample &&
        (this.sample.soilArea.location ||
          (this.sample.soilArea.polygon &&
            this.sample.soilArea.polygon.length > 0))
      ) {
        this.SET_SHOW_ALL(true);
      } else {
        if (this.sample.samplePhotos.length > 0) {
          this.urls = [
            {
              img: this.sample.samplePhotos[0].photo,
              description: "",
            },
          ];
        }
        this.sheet = true;
      }
    },
    openDialog(description, pheno) {
      this.dialog = !this.dialog;
      this.description = description;
      this.pheno = pheno ? pheno : "";
    },
    getPeheno(item) {
      return this.translations.phenologicalStages[item] || item;
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("samples", ["area_selected"]),
    ...mapState("samples", ["sample_selected"]),
    ...mapState("areasList", ["crops"]),
  },
  async mounted() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
    try {
      let response = await this.getSampleById(this.$route.params.sampleId);
      if (response) {
        if (!response.error) {
          this.soilArea = response.sample.soilArea;
          this.sample = response.sample;
          let template = "";
          if (this.sample.folioAnalysis) {
            template += this.sample.folioAnalysis + " - ";
          }
          if (
            this.sample.tracingStatus == "INITIAL" ||
            this.sample.tracingStatus == "Initial"
          ) {
            template += this.translations.analysisTypes["INITIAL"];
          } else {
            template += this.translations.analysisTypes["MONITORING"];
          }

          if (this.sample.sampleType) {
            switch (this.sample.sampleType) {
              case "MAS":
                template += " - " + this.translations.label_genomic_sample;
                break;
              case "MAS_VEGETABLE":
                template +=
                  " - " + this.translations.label_genomic_plant_sample;
                break;
              case "CLASSIC":
                template += " - " + this.translations.label_soil_sample;
                break;
              case "VEGETABLE":
                if (
                  this.sample.tracingStatus == "INITIAL" ||
                  this.sample.tracingStatus == "Initial"
                ) {
                  template = this.translations.label_valuation;
                } else {
                  template = this.translations.label_measurement;
                }
                template +=
                  " - " +
                  this.translations.label_plant_sample_without_reference;
                break;
              case "COMPOST":
                if (
                  this.sample.tracingStatus == "INITIAL" ||
                  this.sample.tracingStatus == "Initial"
                ) {
                  template = this.translations.label_valuation;
                } else {
                  template = this.translations.label_measurement;
                }
                template += " - " + this.translations.label_compost_sample;
                if (this.sample.composition) {
                  template += ` - ${this.translations.compotition_types[this.sample.composition]
                    }`;
                }
                break;
              case "PRODUCT":
                if (
                  this.sample.tracingStatus == "INITIAL" ||
                  this.sample.tracingStatus == "Initial"
                ) {
                  template = this.translations.label_valuation;
                } else {
                  template = this.translations.label_measurement;
                }
                template += " -" + this.translations.label_product_sample;
                if (this.sample.composition) {
                  template += ` - ${this.translations.compotition_types[this.sample.composition]
                    }`;
                }
                break;
              case "SUBSTRATUM":
                if (
                  this.sample.tracingStatus == "INITIAL" ||
                  this.sample.tracingStatus == "Initial"
                ) {
                  template = this.translations.label_valuation;
                } else {
                  template = this.translations.label_measurement;
                }
                template += " - " + this.translations.label_substrate_sample;
                break;
              case "NO_ADVISOR":
                template +=
                  " - " + this.translations.label_sample_without_advisor;
                break;
            }
          }

          this.fullNameSample = template;
          await this.getCropName();
          if (this.sample.status == "IN_PROGRESS") {
            this.dateFormatted = this.getFormatted(this.sample.startDate);
          } else {
            this.dateFormatted = this.getFormatted(this.sample.endDate);
          }
          // else if (this.status_sample == "VALIDATED") {
          //   this.dateFormatted = this.getFormatted(this.sample.endDate);
          // }
          // else if (this.status_sample == "SENT") {
          //   this.dateFormatted = this.getFormatted(this.sample.endDate);
          // } else if (this.status_sample == "RECEIVED") {
          //   this.dateFormatted = this.getFormatted(this.sample.endDate);
          // } else if (this.status_sample == "ANALYZING") {
          //   this.dateFormatted = this.getFormatted(this.sample.endDate);
          // } else if (this.status_sample == "ANALYZED") {
          //   this.dateFormatted = this.getFormatted(this.sample.endDate);
          // }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    } catch (e) {
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
  },
  async created() {
    // this.soilArea = this.area_selected;
    // this.sample = this.sample_selected;
    // this.status_sample = this.sample.status;
    // this.status_area = this.soilArea.status;
    // if (this.status_sample == "NOT_STARTED") {
    // } else if (this.status_sample == "IN_PROGRESS") {
    //   this.dateFormatted = this.getFormatted(this.sample.startDate);
    // } else if (this.status_sample == "VALIDATED") {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // } else if (this.status_sample == "SENT") {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // } else if (this.status_sample == "RECEIVED") {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // } else if (this.status_sample == "ANALYZING") {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // } else if (this.status_sample == "ANALYZED") {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // } else {
    //   this.dateFormatted = this.getFormatted(this.sample.endDate);
    // }
  },
  components: {
    MapSample,
    UpdateSampleInfoModal,
  },
};
</script>

<style scoped>
.sample--code {
  font-weight: bold;
  font-size: 0.9rem;
}

.sample--empty-info {
  font-size: 0.8rem;
}

.sample--date {
  font-size: 0.82rem;
  color: #818181;
}

.sample--tiny-info {
  font-size: 0.82rem;
}

.here-map__container {
  width: auto;
  height: 50vh;
  margin: 10px;
}
</style>
